import { render } from "./ConfigTable.vue?vue&type=template&id=bc319b20&scoped=true"
import script from "./ConfigTable.vue?vue&type=script&lang=js"
export * from "./ConfigTable.vue?vue&type=script&lang=js"

import "./ConfigTable.vue?vue&type=style&index=0&id=bc319b20&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc319b20"]])

export default __exports__